import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Input } from 'antd';
import { debounce } from 'lodash';
import queryString from 'query-string';
import cx from 'classnames';

import { WorkersSectionsEnum } from 'features/worker/enums';

type Props = {
  className?: string;
  searchQuery?: string;
};

interface SearchQueryModel {
  query?: string;
  section: WorkersSectionsEnum;
}

export default function ContractorCompanySearch(props: Props) {
  const { searchQuery = '', className = '' } = props;
  const [query, setQuery] = useState(searchQuery);
  const navigate = useNavigate();
  const location = useLocation();
  const { section } = queryString.parse(location.search);

  useEffect(() => {
    setQuery(searchQuery);
  }, [searchQuery]);

  const onSearchContractorCompanies = useCallback(
    (value: string) => {
      const queryData: SearchQueryModel = {
        section,
      };

      value && (queryData.query = value);

      navigate(`${location.pathname}?${queryString.stringify(queryData)}`, {
        replace: true,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [section],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearch = useCallback(
    debounce(onSearchContractorCompanies, 100),
    [onSearchContractorCompanies],
  );

  const handleAutoCompleteChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const {
      target: { value },
    } = event;

    setQuery(value);
    debounceSearch(value);
  };

  return (
    <div className={cx(className)}>
      <Input
        value={query}
        placeholder="Search by contractor company name, ID"
        onChange={handleAutoCompleteChange}
        autoComplete="off"
      />
    </div>
  );
}
